<template>
  <div>
    <div class="filter-cat-name" :class="`category_${categoryIndex}`">
      <div class="f22-l30-sb mw cat-name" v-html="category.text"></div>
      <div v-if="category.loyalty_text" class="f22-l30-sb mw loyalty-cat-name" v-html="category.loyalty_text"></div>
    </div>
    <div :class="clazz()" dir="rtl" :id="'category_' + category.category_id" class="mw p-0">
      <div class="col-12 col-xl-4 col-md-6" v-for="d in dishes" :key="d.dish.url_title">
        <DishInMenuCardComponent :dish="d.dish" />
      </div>
    </div>
  </div>
</template>
<script>
import DishInMenuCardComponent from "@/components/DishInMenuCardComponent.vue";
export default {
  components: {
    DishInMenuCardComponent
  },
  props: {
    category: Object,
    categoryIndex: Number,
    dishes: Array
  },
  methods: {
    clazz() {
      return this.$isDesktop(true) ? "row" : "row-fluid";
    }
  }
}
</script>
<style scoped>
.filter-cat-name.category_0 {
  color: black;
  background-color: white;
  min-height: 28px;
  margin: 0 -12px 0 -12px;
  /* padding-right: 43px; */
}
.filter-cat-name {
  color: white;
  background-color: rgb(56, 56, 59);
  min-height: 28px;
  margin: 0 -12px 0 -12px;
  /* padding-right: 43px; */
}

.cat-name {
  margin-top: 20px;
  padding-right: 12px;
  padding-left: 12px;
}
.loyalty-cat-name {
  padding-right: 12px;
  padding-left: 12px;
}
</style>